export default "__VITE_ASSET__1A9JKCto__"